export default __webpack_public_path__ + "61c95d696a9481ab81c60dc41c065abf.png";